<nav-mobile #navMobile></nav-mobile>
<main class="base">
  <!-- Prehead mobile onlye -->
  <section class="prehead">
    <button mat-icon-button (click)="navMobile.openNav()" class='custom-mat-icon-button button-sandwich'>
      <mat-icon>menu</mat-icon>
    </button>
    <div class="logo black"></div>
    <button mat-icon-button class='custom-mat-icon-button button-search'><mat-icon>search</mat-icon></button>
  </section>
  <!-- Sidenav desktop only -->
  <nav-side [_sideNavMenuOptionActive]="sideNavMenuOptionActive" [_toggleSideNav]="toggleSideNav"></nav-side>
  <section [class]="'sidenav-handler'" [ngClass]="{'sidenav--is--float': toggleSideNav}" (click)="onClickSideNavHandler()">
  </section>
  <!-- Main Router Outlet -->
  <section [class]="'page'" [ngClass]="{'sidenav--is--float': toggleSideNav}" [@fadeInAnimation]="outlet.isActivated ? outlet.activatedRoute : ''">
    <banner-test></banner-test>
    <system-message></system-message>
    <router-outlet #outlet="outlet"></router-outlet>
  </section>
</main>
<panel-help #panelHelp></panel-help>
